import { useEffect, useState } from "react";

const ClosedBetaData = () => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const content1 = `Beta registration closed`;
  const content2 = `Thank you for participating!`;
  const pStyleDeskTop = {
    fontSize: "24px",
    color: "white",
    textAlign: "center",
    fontFamily:"sans-serif,Georgia,Times",
    // whiteSoace: "pre-wrap",
  };

  const pStyleMobile = {
    fontSize: "14px",
    color: "white",
    textAlign: "center",
    fontFamily:"sans-serif,Georgia,Times",
  };

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });
  return (
    <div style={{  display:"flex", justifyContent:"center", padding: "0px 30px" }}>
      {windowSize > 600 && <p style={pStyleDeskTop}>{content1}<br/>{content2}</p>}
      {windowSize <= 600 && <p style={pStyleMobile}>{content1}<br/>{content2}</p>}
    </div>
  );
};

export default ClosedBetaData;
